import { createProvider } from '@nvision/services/data-provider';
import { queryOptions } from '@tanstack/react-query';

import { CACHE_KEYS } from '../../types';
import { logger } from '../../utils/logger';
import { normalizeAccessorial, normalizeAvailableAccessorialCodes } from '../normalize';
import * as api from './api';

export const fetchAccessorial = createProvider(api.fetchAccessorial)
  .andThen(normalizeAccessorial)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      logger.warn('Fetch accessorial aborted');
    } else {
      logger.error('Fetch accessorial failed:', error);
    }
    throw error;
  });

export const accessorialQueryOptions = (accessorialKey: number) =>
  queryOptions({
    queryFn: ({ signal }) => fetchAccessorial({ accessorialKey }, { signal }),
    queryKey: CACHE_KEYS.accessorial(accessorialKey),
    // biome-ignore lint/style/noMagicNumbers: 1 hour
    staleTime: 1000 * 60 * 60,
  });

export const fetchAvailableAccessorialCodes = createProvider(api.fetchAvailableAccessorialCodes).andThen((res) =>
  normalizeAvailableAccessorialCodes(res),
);

export const availableAccessorialCodesQueryOptions = () =>
  queryOptions({
    queryFn: ({ signal }) => fetchAvailableAccessorialCodes({ signal }),
    queryKey: CACHE_KEYS.availableAccessorialCodes(),
    // biome-ignore lint/style/noMagicNumbers: 1 hour
    staleTime: 1000 * 60 * 60,
  });
